import { renderContentBlocks } from '../../../../../../../../../../../backend/src/shared/render-content-blocks';
import { ContentBlock } from '../../../../../../../../../../../backend/src/types/types';

export const REF_PLACEHOLDER_TAG = 'kimref';
export const ARTIFACT_PLACEHOLDER_TAG = 'kimartifact';

// The block walk (including the table repairs for streamed rows) is shared with the backend
// Word export so the exported document lays out exactly like the rendered thread.
export function formatContent(blocks: ContentBlock[]): string {
  return renderContentBlocks(blocks, {
    text: (value) => value,
    artifact: (block) =>
      `<${ARTIFACT_PLACEHOLDER_TAG} data-id="${block.id}-${block.versionNumber}"></${ARTIFACT_PLACEHOLDER_TAG}>`,
    reference: (block) =>
      `<${REF_PLACEHOLDER_TAG} data-id="${block.id}" data-ref-type="${block.refType}"></${REF_PLACEHOLDER_TAG}>`,
  });
}
